import { useTypedQuery } from "hooks";
import { CarDetailsQueryKeys } from "modules/CarDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DefaultError } from "@tanstack/react-query";
import type { Appointment } from "models";

type HoldingAppointmentHistoryDataProps = {
  loading: boolean;
  error: DefaultError | null;
  holdingAppointments?: Appointment[];
};

const sortAppointments = (appointments: Appointment[]) => appointments.toSorted((a, b) => b.time_car_app.localeCompare(a.time_car_app));

export const useHoldingAppointmentHistoryQuery = (car_id?: number): HoldingAppointmentHistoryDataProps => {
  const {
    data: holdingAppointments,
    isFetching,
    error
  } = useTypedQuery({
    enabled: car_id !== undefined,
    queryKey: CarDetailsQueryKeys.holdingAppointmentHistory(car_id),
    queryFn: async ({ baseUrl, endpoint, params }) => (await ApiInstance.post(endpoint, params, baseUrl)).data.appointments,
    select: sortAppointments
  });

  return { holdingAppointments, loading: isFetching, error };
};
